module.exports = __webpack_public_path__ + "static/img/prize_title.de880bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/winterOlympics/dialog/prize_title.png
// module id = Pq8M
// module chunks = 33